import { useLocation } from "react-router-dom";
import {
  PartnerMeta,
  PartnerSlug,
  partnerMetaBySlug,
  partnerSlugs,
} from "../config/constants";

interface UsePartner {
  isPartner: boolean;
  partnerSlug: string;
  partnerSlugify: (route: string) => string;
  partnerMeta: PartnerMeta;
}

export const usePartner = (): UsePartner => {
  const location = useLocation();
  const partnerSlug = (
    location.pathname.split("/")[1] == "partner"
      ? location.pathname.split("/")[2]
      : ""
  ) as any;
  const isPartner = partnerSlugs.includes(partnerSlug);
  const partnerMeta = isPartner
    ? partnerMetaBySlug[partnerSlug as PartnerSlug]
    : {
        name: "",
        email: "",
      };

  return {
    isPartner,
    partnerSlug,
    partnerSlugify: partnerSlugify(partnerSlug),
    partnerMeta: {
      name: partnerMeta.name,
      email: partnerMeta.email,
    },
  };
};

const partnerSlugify = (partnerSlug: string) => (route: string) => {
  if (!partnerSlug) return route;

  const partnerRoute = route.replace(":slug", partnerSlug);

  return partnerRoute;
};
